/**
 * Custom events map
 * @module lang
 */

const events = {
  ajax: 'ajax',
  ready: 'ready',
  settings: 'settings',
  route: 'route',
  error: 'error'
}

export default events



// WEBPACK FOOTER //
// ./src/helpers/events.js